import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function HotelsInKharadi(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
    const faqs = [
        {
          question: "What types of rooms are available at Om Sai PG?",
          answer: "Om Sai PG offers both single and shared rooms to accommodate the varying needs of students and professionals. Each room is well-furnished and designed for maximum comfort."
        },
        {
          question: "What facilities are provided in the rooms?",
          answer: "All rooms come equipped with a comfortable bed, study table, chair, wardrobe, fan, and high-speed Wi-Fi. We also provide daily housekeeping services to maintain cleanliness."
        },
        {
          question: "Is food provided at Om Sai PG?",
          answer: "Yes, Om Sai PG offers nutritious, home-style meals for breakfast, lunch, and dinner. We provide vegetarian options and cater to different dietary preferences."
        },
        {
          question: "How is the security at Om Sai PG?",
          answer: "Om Sai PG ensures 24/7 security with CCTV surveillance, security guards at the entrance, and restricted access to ensure the safety of all residents."
        },
        {
          question: "Is there a provision for laundry at Om Sai PG?",
          answer: "Yes, Om Sai PG provides laundry services for a reasonable charge. You can get your clothes washed and ironed at regular intervals."
        },
        {
          question: "Is there a curfew at Om Sai PG?",
          answer: "There is no strict curfew at Om Sai PG, but we request residents to respect the hostel timings and maintain peace after a certain hour for the comfort of all."
        },
        {
          question: "What is the pricing for accommodation at Om Sai PG?",
          answer: "The pricing at Om Sai PG is affordable and varies depending on the type of room you choose. We offer competitive rates, ensuring value for money while maintaining a high standard of living."
        },
        {
          question: "Can I stay at Om Sai PG for a short duration?",
          answer: "Yes, Om Sai PG offers flexible stay options. Whether you need accommodation for a few weeks or months, we can accommodate short-term stays based on availability."
        },
        {
          question: "Are guests allowed at Om Sai PG?",
          answer: "Om Sai PG allows guests, but they need to register at the reception and are only allowed during certain hours. Residents are responsible for their guests' conduct."
        },
        {
          question: "How far is Om Sai PG from the nearest transportation hubs?",
          answer: "Om Sai PG is conveniently located near bus stops and railway stations, with easy access to public transportation, making commuting to work or college hassle-free."
        }
      ];
      
      const testimonials = [
        {
          quote: "OM Sai PG in Kharadi is hands down the best place to stay for working professionals or students looking for a home away from home. The rooms are spacious, clean, and well-maintained. The management is extremely supportive and takes care of every need. The food is delicious, and the common areas are perfect for socializing or unwinding after a busy day. The location is very convenient, with easy access to transport and nearby amenities. I highly recommend OM Sai PG for anyone looking for a comfortable and safe place to stay in Kharadi.",
          author: "- Ravi Kumar, IT Professional"
        },
        {
          quote: "I’ve been staying at OM Sai PG for the past six months, and I couldn’t be happier. The facilities provided are top-notch, with high-speed Wi-Fi, a clean kitchen, and laundry services. The management team is always friendly and responsive, which makes life here very comfortable. The location is also a big plus, as it’s very close to my office and local shops. The peaceful environment and excellent service make OM Sai PG the perfect choice for anyone looking for a hassle-free and comfortable stay in Kharadi.",
          author: "- Neha Desai, Marketing Executive"
        }
      ];
      
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
    
    
    return(
        <>

<Helmet>
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/Hostels-in-Kharadi",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/images/img/keyword-image/Hostels-in-kharadi.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipgpune@gmail.com",
      "keywords": [
        "PG in Kharadi",
        "Hostel in Kharadi",
        "Om Sai PG",
        "PG with food in Pune",
        "Paying Guest Kharadi",
        "PG for students in Kharadi",
        "Hostel for males in Kharadi"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>Om Sai PG | Hostel in Kharadi | PG with Food | Paying Guest in Kharadi</title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG in Kharadi, Pune, offers affordable PG accommodations with food for students and working professionals. Comfortable, safe, and well-located near Eon IT Park."
  />
  <meta
    name="keywords"
    content="PG in Kharadi, Hostel in Kharadi, Om Sai PG, PG with food in Pune, Paying Guest Kharadi, PG for students in Kharadi, Hostel for males in Kharadi"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for affordable PG accommodation in Kharadi Pune? Om Sai PG offers PGs with food and all essential amenities for students, professionals, and residents."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/Hostels-in-kharadi.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/Hostels-in-Kharadi" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Om Sai PG" />
</Helmet>


     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img2">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Hostels in Kharadi</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Hostels in Kharadi</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>Hostels in Kharadi</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/Hostels-in-kharadi.jpg" className="img-fluid" alt="Hotels near Kharadi" />
              </div>
              <h1>Om Sai PG Hostel in Kharadi, Pune</h1>
    <p>Om Sai PG Hostel offers comfortable and affordable accommodations for both males and females in the heart of Kharadi, Pune. Located in a prime location, Om Sai PG is ideal for professionals, students, and individuals looking for a secure, convenient, and homely environment.</p>

    <h2>Features of Om Sai PG:</h2>
    <h3>Affordable Rent</h3>
    <p>Competitive pricing for both shared and private rooms.</p>

    <h3>24/7 Security</h3>
    <p>CCTV cameras and on-site staff to ensure a safe and peaceful stay.</p>

    <h3>Meals</h3>
    <p>Healthy, home-style food with options for breakfast, lunch, and dinner.</p>

    <h3>Wi-Fi and Utilities</h3>
    <p>High-speed internet and other essential utilities.</p>

    <h3>Near Key Locations</h3>
    <p>Proximity to IT hubs like Eon IT Park, World Trade Center, and Pune Airport.</p>

    <hr/>

    <h1>Hostel in Kharadi, Pune</h1>
    <p>Hostels in Kharadi provide a wide range of accommodation options, catering to both working professionals and students. Kharadi is a popular area for its proximity to IT hubs, shopping malls, and excellent transportation connections.</p>

    <h2>Why Choose a Hostel in Kharadi?</h2>
    <h3>Connectivity</h3>
    <p>Easy access to key locations like Koregaon Park, Viman Nagar, and Magarpatta.</p>

    <h3>Affordable Living</h3>
    <p>Great options for budget-friendly stays in the city.</p>

    <h3>Proximity to IT Parks</h3>
    <p>Ideal for employees working in IT companies and tech parks.</p>

    <h3>Comfortable Living</h3>
    <p>A homely environment with necessary amenities for a comfortable stay.</p>

    <hr/>

    <h1>Hostel Near Kharadi, Pune</h1>
    <p>For individuals looking for a hostel near Kharadi, several options in nearby areas such as Viman Nagar, Wagholi, and Magarpatta provide convenience with a slightly different cost and ambiance.</p>

    <h2>Benefits of Staying Near Kharadi:</h2>
    <h3>Access to Transport</h3>
    <p>Well-connected by road and public transport to major hubs like Pune Railway Station and the Airport.</p>

    <h3>Peaceful Surroundings</h3>
    <p>Residential areas that are quieter but still close to the main attractions.</p>

    <h3>Easy Commute</h3>
    <p>Stay close to Kharadi without the need to travel long distances for work or leisure.</p>

    <hr/>

    <h1>Ladies Hostel in Kharadi, Pune</h1>
    <p>A ladies hostel in Kharadi is specifically designed to offer a secure, comfortable, and welcoming environment for working women and students. The facilities cater to the specific needs of female residents, with a focus on safety and privacy.</p>

    <h2>Key Features:</h2>
    <h3>Female-Only Accommodation</h3>
    <p>A women-only space to ensure comfort and privacy.</p>

    <h3>Security</h3>
    <p>Female security staff, CCTV surveillance, and secure access points.</p>

    <h3>Friendly Environment</h3>
    <p>A warm, community-based atmosphere for women who live away from home.</p>

    <h3>Meals and Laundry</h3>
    <p>Nutritious meals and laundry services for convenience.</p>




            <h2>Om Sai PG for "Single Room PG in Pune" Contact Number:- </h2>
            <p>Contact Om Sai PG at +91 9763888448 / +91 9922248255. Our PG is strategically located in the heart of Kharadi, one of Pune's most vibrant and accessible neighborhoods, making it an ideal choice for students and professionals alike.</p>

            
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Hostels in Kharadi</p>
<p> - Kharadi Hostel</p>
<p> - Hostel Near Kharadi</p>
<p> - Ladies Hostel in Kharadi</p>
<p> - Working Women's Hostel in Kharadi</p>
<p> - Hostel Accommodation in Kharadi Pune</p>
<p> - PG Hostels in Kharadi Pune</p>
                    </td>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Boys Hostel in Kharadi</p>
<p> - Working Bachelor Hostel in Kharadi</p>
<p> - Working Women's Hostel in Kharadi</p>
<p> - Hostels in Chandanagar</p>
<p> - Hostels in Wagholi Pune</p>
<p> - Hostels in Wadgaon Sheri</p>
<p> - Hotels in Pune Nagar Road</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <h1>Why Choose "Om Sai PG" for Hostels in Kharadi?</h1>
    <p>Om Sai PG stands out as an ideal choice for those looking for comfortable and reliable hostel accommodation in Kharadi, Pune. Here are some reasons to choose this PG:</p>
    
    <h2>1. Prime Location</h2>
    <p>Located in Kharadi, one of the fastest-growing areas in Pune, Om Sai PG offers easy access to major business hubs, tech parks, and educational institutions, making it perfect for students and professionals alike.</p>

    <h2>2. Affordable & Competitive Pricing</h2>
    <p>Om Sai PG offers pocket-friendly pricing without compromising on quality. The hostel is tailored to meet the needs of budget-conscious individuals looking for high-value accommodation.</p>

    <h2>3. Fully Furnished Rooms</h2>
    <p>The hostel provides well-maintained, spacious rooms with modern furniture, ensuring comfort for all residents. The rooms come with essential amenities like a bed, wardrobe, study table, and fans.</p>

    <h2>4. Cleanliness & Hygiene</h2>
    <p>The hostel maintains high standards of cleanliness and hygiene, providing regular cleaning services to ensure a safe and comfortable living environment for all residents.</p>

    <h2>5. 24/7 Security & Surveillance</h2>
    <p>Om Sai PG ensures the safety of its residents by offering round-the-clock security services, including CCTV surveillance and security guards at the entrance.</p>

    <h2>6. Free High-Speed Wi-Fi</h2>
    <p>The hostel provides free high-speed internet, which is a must-have for both students and professionals who need to stay connected for study or work purposes.</p>

    <h2>7. Nutritious & Hygienic Food</h2>
    <p>The hostel offers freshly prepared, nutritious, and home-style meals that cater to various dietary preferences. This ensures that all residents get healthy meals daily.</p>

    <h2>8. Friendly Atmosphere</h2>
    <p>The hostel fosters a friendly and community-oriented environment where residents can connect with each other, making it easy for new people to adjust and build relationships.</p>

    <h2>9. Recreational Facilities</h2>
    <p>Om Sai PG provides recreational facilities like TV rooms and common areas for residents to unwind, relax, or socialize with fellow boarders.</p>

    <h2>10. Well-Connected Transportation</h2>
    <p>The hostel is well-connected to public transport, with buses and rickshaws easily accessible. This ensures residents can commute conveniently to nearby locations.</p>


              <div className="">
                  <h2>
                  FAQs of "Om Sai PG" for Hostels in Kharadi ?
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonial for “Om Sai PG” for Hostels in Kharadi: -  {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
